import { analytics } from '@app/app/analytics';
import { PlatformName } from '@app/app/analytics/types';

export class FetchError extends Error {
  constructor(
    message: string,
    public url: string,
    public httpCode?: number,
  ) {
    super(message);
    this.name = 'FetchError';
  }
}

export const handleFetchError = (error: FetchError, fileId?: string) => {
  analytics.emitEvent('service_error_system', {
    [PlatformName.GTM]: {
      action: error.url,
      message: JSON.stringify(error),
      fileID: fileId,
      httpCode: error.httpCode,
    },
  });
};
